import { z } from "zod";

export const schemaEntrar = z.object({
	username: z.string().min(1, "Campo obrigatório").nonempty("Por favor, digite seu usuário."),
	password: z.string().optional(),
});

export const valoresPadraoEntrar = {
	username: "",
	password: "",
};

export type FormularioEntrarType = z.infer<typeof schemaEntrar>;
